import { Entity } from '@sketchpixy/rubix/lib/L20n';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { GREEN, PERMISSIONS, PERMISSION_ENTITIES, RED } from '../../../_config/consts';
import CheckOutlineIconCustom from '../../CustomIcons/CheckOutlineIconCustom.jsx';
import AbilityProvider from '../../../permissionsUtils/AbilityProvider.js';
import * as ModalActions from '../../../redux/actions/modal.actions';
import * as SettingsActions from '../../../redux/actions/setting.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import MDButton from '../../MDButton/MDButton.jsx';
import Permission from '../../Permission/Permission.jsx';
import FormFlatContainer from '../../forms/Elements/FormFlatContainer.jsx';

@connect()
class Office365ScimProvisioningSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accessToken: null,
      expiresAt: null,
      copied: false,
      isGenerating: false,
      isRevoking: false,
      scimProvisioningUser: null,
      scimStatusLoading: true,
    };
  }

  componentDidMount() {
    this.loadScimProvisioningStatus();
  }

  async loadScimProvisioningStatus() {
    const { dispatch } = this.props;
    this.setState({ scimStatusLoading: true });
    try {
      const scimProvisioningUser = await dispatch(SettingsActions.fetchScimProvisioningUser());
      this.setState({ scimProvisioningUser, scimStatusLoading: false });
    } catch (error) {
      this.setState({ scimProvisioningUser: null, scimStatusLoading: false });
    }
  }

  async onGenerateToken() {
    const { dispatch } = this.props;
    this.setState({ isGenerating: true, copied: false });
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const { accessToken, expiresAt } = await dispatch(SettingsActions.generateCompanyScimToken());
      this.setState({ accessToken, expiresAt, isGenerating: false });
      await this.loadScimProvisioningStatus();
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      this.setState({ isGenerating: false });
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="office365ScimGenerateError" /></h6>),
        },
      }));
    }
  }

  onRevokeTokenRequest() {
    const { dispatch } = this.props;
    dispatch(ModalActions.showModal({
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="office365ScimRevokeConfirm" />,
        onConfirmText: <Entity entity="yes" />,
        onConfirm: () => this.onRevokeToken(),
        onCancelText: <Entity entity="no" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    }));
  }

  async onRevokeToken() {
    const { dispatch } = this.props;
    this.setState({ isRevoking: true });
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      await dispatch(SettingsActions.revokeCompanyScimToken());
      this.setState({ accessToken: null, expiresAt: null, copied: false, isRevoking: false });
      await this.loadScimProvisioningStatus();
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="office365ScimRevokeSuccess" /></h6>),
        },
      }));
    } catch (error) {
      this.setState({ isRevoking: false });
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="office365ScimRevokeError" /></h6>),
        },
      }));
    }
  }

  async onCopyToken() {
    const { accessToken } = this.state;
    try {
      await navigator.clipboard.writeText(accessToken);
      this.setState({ copied: true });
    } catch (error) {
      this.setState({ copied: false });
    }
  }

  render() {
    const {
      accessToken, expiresAt, copied, isGenerating, isRevoking, scimProvisioningUser, scimStatusLoading,
    } = this.state;
    const { containerStyle } = this.props;
    const canUpdateCompany = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.UPDATE], PERMISSION_ENTITIES.COMPANY);
    const scimTokenActive = scimProvisioningUser && scimProvisioningUser.enabled;
    const scimTokenRevoked = scimProvisioningUser && !scimProvisioningUser.enabled;

    return (
      <FormFlatContainer
        title="office365ScimTitle"
        subtitle="office365ScimDescription"
        containerStyle={{ marginTop: 30, marginBottom: 20, ...containerStyle }}
      >
        {!scimStatusLoading ? (
          <div style={{ marginBottom: 16 }}>
            {scimTokenActive ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <CheckOutlineIconCustom style={{ color: GREEN, width: 22, marginRight: 8 }} />
                <h5 style={{ margin: 0, color: GREEN, fontSize: 15, fontWeight: 'bold' }}>
                  <Entity entity="office365ScimStatusActive" />
                </h5>
              </div>
            ) : null}
            {scimTokenRevoked ? (
              <h5 style={{ margin: 0, color: '#d97706', fontSize: 15, fontWeight: 'bold' }}>
                <Entity entity="office365ScimStatusRevoked" />
              </h5>
            ) : null}
            {!scimProvisioningUser ? (
              <h5 style={{ margin: 0, color: '#757575', fontSize: 15 }}>
                <Entity entity="office365ScimStatusNone" />
              </h5>
            ) : null}
          </div>
        ) : null}
        {accessToken ? (
          <div style={{ marginBottom: 16 }}>
            <h4 style={{ fontSize: 16, marginTop: 0, color: '#3f3f3f', fontWeight: 'bold' }}>
              <Entity entity="office365ScimTokenOnce" />
            </h4>
            <div style={{ background: 'white', borderRadius: 8, padding: 12, wordBreak: 'break-all', fontFamily: 'monospace', fontSize: 14 }}>
              {accessToken}
            </div>
            {expiresAt ? (
              <h5 style={{ fontSize: 14, color: '#3f3f3f', marginTop: 10 }}>
                <Entity entity="office365ScimExpiresAt" data={{ date: moment(expiresAt).format('LLL') }} />
              </h5>
            ) : null}
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginTop: 10 }}>
              <MDButton
                containerStyle={{ marginLeft: 0, width: 'auto' }}
                title={<Entity entity={copied ? 'office365ScimCopied' : 'office365ScimCopy'} />}
                onClick={() => this.onCopyToken()}
              />
              <MDButton
                containerStyle={{ width: 'auto' }}
                backgroundColor="#757575"
                title={<Entity entity="office365ScimHideToken" />}
                onClick={() => this.setState({ accessToken: null, expiresAt: null, copied: false })}
              />
            </div>
          </div>
        ) : null}
        <Permission do={[PERMISSIONS.UPDATE]} on={PERMISSION_ENTITIES.COMPANY} abilityHelper={AbilityProvider.getAbilityHelper()}>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 10 }}>
            <MDButton
              containerStyle={{ marginLeft: 0, width: 'auto' }}
              title={<Entity entity="office365ScimGenerate" />}
              disabled={!canUpdateCompany || isGenerating}
              isLoading={isGenerating}
              onClick={() => this.onGenerateToken()}
            />
            <MDButton
              containerStyle={{ marginLeft: 0, width: 'auto' }}
              backgroundColor={RED}
              title={<Entity entity="office365ScimRevoke" />}
              disabled={!canUpdateCompany || isRevoking}
              isLoading={isRevoking}
              onClick={() => this.onRevokeTokenRequest()}
            />
          </div>
        </Permission>
      </FormFlatContainer>
    );
  }
}

export default Office365ScimProvisioningSection;
